import React from 'react'
import { csx, IconWarningCircle, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { ShelfWithoutDataContainer } from '../ShelfWithoutDataContainer'

export const CollectionsShelfEmptyState = () => {
  return (
    <ShelfWithoutDataContainer data-testid="collections-shelf-empty-state">
      <IconWarningCircle
        width={32}
        height={32}
        className={csx({ color: '$gray30', marginBottom: '$space-3' })}
      />
      <Text variant="action1">
        <FormattedMessage id="collectionsShelfEmptyStateTitle" />
      </Text>
      <Text variant="detail" className={csx({ color: '#858585 !important' })}>
        <FormattedMessage id="collectionsShelfEmptyStateDescription" />
      </Text>
    </ShelfWithoutDataContainer>
  )
}
